import confetti from 'canvas-confetti';

// note: you CAN only use a path for confetti.shapeFrompath(), but for
// performance reasons it is best to use it once in development and save
// the result to avoid the performance penalty at runtime

// Create shape from the Livingstone logo paths
const livingstoneLogo = confetti.shapeFromPath({
  path: 'M118.683 89.0447L100.222 78.3861C93.3804 74.4362 87.8344 71.2343 87.8344 71.2343L110.026 32.7979L93.5402 23.28L78.8009 48.8092C69.5945 64.7552 75.058 85.1453 91.0039 94.3518L109.465 105.01L118.683 89.0447Z M18.237 74.4466C28.1007 76.0713 59.9407 81.5432 59.9407 81.5432L40.2895 115.58L56.7749 125.098L66.2085 108.759C77.8587 88.5799 65.7444 62.9792 42.7539 59.1925L21.3306 55.664L18.237 74.4466Z',
});

const defaults = {
  scalar: 4,
  spread: 180,
  zIndex: 202,
  particleCount: 100,
  origin: { y: -0.1 },
  startVelocity: -50,
};

export const tengonfetti = () => {
  confetti({
    ...defaults,
    shapes: [livingstoneLogo],
    colors: ['#1A65E5'],
  });
};
